import React from "react";
import styles from "./styles/MesSystems.module.css";
import { Reveal } from "../Home/common/Reveal";

import mesImg from "../../../images/mes.jpg";

export default function MesSystems() {
  return (
    <section className={styles.section}>
      <div className={styles.container}>
        <div className={styles.header}>
          <h2 className={styles.heading}>Manufacturing Execution Systems</h2>
          <div className={styles.accent} aria-hidden="true" />
          <h3 className={styles.subheading}>Quality Data Capture</h3>
          <p className={styles.intro}>
            All the process systems are centralized by connecting each system with the Central Control unit. The central control unit captures the data from each process system time to time and saves the data in the Central server.
          </p>
        </div>
        <Reveal>
          <div className={styles.imageWrapper}>
            <img
              src={mesImg}
              alt="Manufacturing Execution System architecture diagram"
              className={styles.diagramImage}
              loading="lazy"
            />
          </div>
        </Reveal>
      </div>
    </section>
  );
}
